import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CopyIcon } from 'src/assets/icons/bonus-game/copy-icon.svg';
import { ReactComponent as ShareIcon } from 'src/assets/icons/bonus-game/share-icon.svg';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';
import { ReactComponent as MedalGold } from 'src/assets/icons/bonus-game/medal-gold.svg';
import { ReactComponent as MedalSilver } from 'src/assets/icons/bonus-game/medal-silver.svg';
import { ReactComponent as MedalBronze } from 'src/assets/icons/bonus-game/medal-bronze.svg';
import { ReactComponent as MedalRegular } from 'src/assets/icons/bonus-game/medal.svg';
import { bonusGameApi } from 'src/api/bonus-game';
import Loader from 'src/pages/Education/components/Loader';
import { MobileHeader } from '../../components/Header';
import {
  CopyButton,
  EarningsValue,
  InfoCard,
  InfoText,
  InviteButton,
  MedalPosition,
  MedalWrapper,
  NoReferralsText,
  ReferralHelper,
  ReferralItemWrapper,
  ReferralsContainer,
  SectionTitle,
  StatItem,
  StatLabel,
  StatsContainer,
  StatValue,
  UserInfo,
  Username,
} from './styled';
import { Promocode } from '../../components/Promocode';
import { PageWrapper } from '../../ui/common';
import { BonusTreeInfoDto } from 'src/api/Api';

const medalIcons = [
  <MedalGold key={'gold'} />,
  <MedalSilver key={'silver'} />,
  <MedalBronze key={'bronze'} />,
];

const getMedalIcon = (position: number) => {
  if (position > 3) {
    return <MedalRegular />;
  }
  return medalIcons[position - 1];
};

export const InviteFriends = () => {
  const [promoCode, setPromoCode] = useState('');
  const [totalEarned, setTotalEarned] = useState(0);
  const [referrals, setReferrals] = useState<BonusTreeInfoDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReferralsData = async () => {
      try {
        setIsLoading(true);

        const promocodeRes = await bonusGameApi.generateInviteCode();
        const referralsRes = await bonusGameApi.getLeaderBoard({
          promoCode: promocodeRes.result.promoCode as any,
        });
        const earnedByRefRes = await bonusGameApi.getEarnedByReferals({
          promoCode: promocodeRes.result.promoCode,
        });

        setReferrals(referralsRes.result);
        setTotalEarned(earnedByRefRes.result);
        setPromoCode(promocodeRes.result.promoCode);
      } catch (error) {
        console.error('Failed to fetch referrals data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReferralsData();
  }, []);

  const handleInviteFriends = () => {
    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'share-popup',
        data: {
          message: `Join me on Haqabi Tree game using my promo code ${promoCode}`,
        },
      }),
    );
  };

  return (
    <PageWrapper>
      <MobileHeader title="Invite friends" />

      <InfoCard>
        <InfoText>
          You and your invited friend will receive 500 coins each after joining
          Haqabi Tree game using this promo code:
        </InfoText>
        <Promocode promoCode={promoCode} />
        <InviteButton onClick={handleInviteFriends}>
          <ShareIcon />
          Invite Friends
        </InviteButton>
      </InfoCard>

      <div
        style={{
          height: '1px',
          backgroundColor: '#53596240',
          margin: '32px 0',
        }}
      />

      <StatsContainer>
        <StatItem>
          <StatLabel>Total referrals</StatLabel>
          <StatValue>{referrals.length}</StatValue>
        </StatItem>
        <StatItem>
          <StatLabel>Earned by referrals total</StatLabel>
          <StatValue style={{ alignSelf: 'flex-end' }}>
            <CoinIcon width={16} height={16} />
            {totalEarned}
          </StatValue>
        </StatItem>
      </StatsContainer>

      <SectionTitle>Top referrals</SectionTitle>
      {/* TODO change load from API */}
      {isLoading ? (
        <Loader small />
      ) : referrals.length > 0 ? (
        referrals.map(referral => (
          <ReferralItemWrapper key={referral.position}>
            <UserInfo>
              <MedalWrapper>
                {getMedalIcon(Number(referral.position))}
                <MedalPosition
                  style={{
                    color:
                      Number(referral.position) > 2
                        ? '#fff'
                        : 'rgba(0, 0, 0, 0.8)',
                  }}>
                  {referral.position}
                </MedalPosition>
              </MedalWrapper>
              <Username>{referral.bonusTreeName}</Username>
            </UserInfo>
            <EarningsValue>
              <CoinIcon width={16} height={16} />
              {referral.rating.toLocaleString()}
            </EarningsValue>
          </ReferralItemWrapper>
        ))
      ) : (
        <ReferralsContainer>
          <NoReferralsText>No referrals here yet</NoReferralsText>
          <ReferralHelper>
            Earn rewards by inviting your friends!
          </ReferralHelper>
        </ReferralsContainer>
      )}
    </PageWrapper>
  );
};
